import { render } from "./InfoTooltip.vue?vue&type=template&id=3a236a53"
const script = {}

import "./InfoTooltip.vue?vue&type=style&index=0&id=3a236a53&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__